import type { ComponentType, ReactNode } from "react";
import { Helmet } from "react-helmet";

import { Button, ButtonLink, ButtonLinkProps, ButtonProps, cn, InputIconProps } from "@/ui";

export type ErrorPageProps = {
  icon?: ComponentType<InputIconProps>;
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  documentTitle?: string;
};

export const ErrorPage = ({
  icon: Icon,
  title,
  description,
  actions,
  documentTitle,
}: ErrorPageProps) => {
  return (
    <>
      {documentTitle && (
        <Helmet>
          <title>{documentTitle}</title>
        </Helmet>
      )}
      <div className="flex h-full items-center justify-center">
        <div className="w-full max-w-md mx-auto bg-surface-1 border border-surface-1 rounded-xl shadow-lg p-8 sm:p-10 flex flex-col">
          {Icon && (
            <div className="flex justify-center mb-5 text-brand" aria-hidden>
              <Icon width={64} height={64} />
            </div>
          )}
          <h1 className="text-center preset-headline-md text-new-primary mb-4">{title}</h1>

          {description && (
            <div className="text-center preset-body-lg text-new-primary space-y-2">
              {description}
            </div>
          )}

          {actions && <div className="flex justify-center mt-6">{actions}</div>}
        </div>
      </div>
    </>
  );
};

export type ErrorPageButtonProps = ButtonProps;

export const ErrorPageButton = ({ children, className, ...props }: ButtonProps) => {
  return (
    <Button size="lg" className={cn("flex-1", className)} {...props}>
      {children}
    </Button>
  );
};

export type ErrorPageButtonLinkProps = ButtonLinkProps;

export const ErrorPageButtonLink = ({ children, className, ...props }: ButtonLinkProps) => {
  return (
    <ButtonLink size="lg" className={cn("flex-1", className)} {...props}>
      {children}
    </ButtonLink>
  );
};
